import React from "react";

// Utils
import { constructPieChartData } from "../../../utils/ChartUtils";

// Components
import { PieChart } from "../../../components/charts/Charts";

// functions
function constructPoiDistAsTotal100(data = {}) {
  const total = Object.values(data).reduce((sum, value) => sum + value, 0);

  if (total < 100) {
    return {
      ...data,
      Others: 100 - total,
    };
  }

  return data;
}

// Location Summary PIE-CHART
export default function LocationSummaryPieChart({
  title = "",
  className = "",
  poiDist,
}) {
  if (!poiDist || Object.keys(poiDist).length === 0) {
    return null;
  }

  // this return True/False ===> if no Poi data then False
  const isPoiDistDataPresent = Object.keys(poiDist).some(
    (key) => poiDist[key] !== 0
  );

  if (!isPoiDistDataPresent) {
    return null;
  }

  // making total as 100% by adding "Others" (only if total is less than 100)
  const poiDistAsTotal100 = constructPoiDistAsTotal100(poiDist);

  const chartData = constructPieChartData(poiDistAsTotal100);

  // Body which to be rendered
  const componentBody = (
    <>
      {title && <h4>{title}</h4>}
      <PieChart data={chartData} />
    </>
  );

  //  Pie chart Rendering
  if (!className) {
    return componentBody;
  }
  return <div className={className}>{componentBody}</div>;
}
